module.exports = __webpack_public_path__ + "img/pantalla.0e8e0aec.png";